import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 📋 راهنمای کاتالوگ‌های وضعیت و دپارتمان‌ها

پلتفرم کارخانه‌سازی میمزاد — سند راهنمای کاربری مدیریت دلایل وضعیت پالت

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## ۱. معرفی کاتالوگ دلایل وضعیت
در سیستم مدیریت انبار، پالت‌ها می‌توانند در وضعیت‌های مختلفی از جمله **آزاد (Available)**، **معلق (Quarantined)**، **مسدود (Blocked)** یا **ضایعات (Scrapped)** قرار گیرند.
برای شفافیت و رهگیری دقیق علت تغییر وضعیت هر پالت، کاتالوگی از دلایل استاندارد به همراه دپارتمان مسئول در این بخش تعریف می‌شود.

## ۲. تعریف دپارتمان‌های مسئول
هر علت تعلیق یا مسدودی پالت می‌تواند به یک دپارتمان سازمانی (مانند کنترل کیفیت QC، انبار، تولید یا نگهداری و تعمیرات PM) مرتبط شود تا گزارش‌های ریشه‌یابی و توقفات کارگاه با دقت ثبت گردد.

export default Layout;

